import React, { useState } from 'react';
import { LogIn, ChevronDown, Menu, ArrowRight, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import logo from '../../assets/logo.jpg';
import '../Navbar/Navbar.css';

const Navbar = () => {
    const navigate = useNavigate();
    const { user, isAdmin, logout, loading } = useAuth();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleLogin = () => {
        navigate('/login');
    };

    const handleLogout = async () => {
        const { error } = await logout();
        if (!error) {
            navigate('/');
        }
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleTakeAssessment = () => {
        if (user) {
            navigate('/quiz-selection');
        } else {
            navigate('/login');
        }
    };

    const handleManageAssessment = () => {
        if (user && isAdmin) {
            navigate('/admin/quizzes');
        } else if (user && !isAdmin) {
            alert('Access denied. Admin privileges required.');
        } else {
            navigate('/login');
        }
    };

    const handleAboutClick = () => {
        if (window.location.pathname === '/') {
            const aboutSection = document.getElementById('about-section');
            aboutSection?.scrollIntoView({ behavior: 'smooth' });
        } else {
            navigate('/', { state: { scrollToAbout: true } });
        }
    };

    const handle5pillarsClick = () => {
        if (window.location.pathname === '/') {
            const pillarsSection = document.getElementById('pillars-section');
            pillarsSection?.scrollIntoView({ behavior: 'smooth' });
        } else {
            navigate('/', { state: { scrollToAbout: true } });
        }
    };

    return (
        <nav className="navbar">
            <div className="nav-brand">
                <img src={logo} alt="Logo" className="logo" />
            </div>
            <button className="menu-btn" onClick={toggleSidebar}>
                {!isSidebarOpen && <Menu size={30} />}
            </button>
            <div className={`nav-links ${isSidebarOpen ? 'open' : ''}`}>
                {isSidebarOpen && (
                    <button className="sidebar-menu-btn" onClick={toggleSidebar}>
                        <ArrowRight size={30} />
                    </button>
                )}
                <a onClick={() => navigate('/')}><span>Home</span></a>
                <a onClick={handleAboutClick}>
                    <span>About</span>
                </a>
                <a onClick={handle5pillarsClick}>
                    <span>Five Pillar Approach</span>
                </a>
                <div className="dropdown">
                    <a href="#services">
                        <span>Services</span>
                        <ChevronDown size={16} />
                    </a>
                    <div className="dropdown-content">
                        <a onClick={() => navigate('/students')}>Students / Job Seekers / Self Awareness</a>
                        <a onClick={() => navigate('/organization')}>Organization</a>
                        <a onClick={() => navigate('/banking-solutions')}>Banking Solutions</a>
                    </div>
                </div>
                <a onClick={() => navigate('/contact')}><span>Contact</span></a>
                
                {/* Show loading state while auth is being determined */}
                {loading ? (
                    <div className="auth-loading" style={{ padding: '8px 16px', fontSize: '14px' }}>
                        Loading...
                    </div>
                ) : user ? (
                    <div className="dropdown profile-dropdown">
                        <img
                            src={user.user_metadata?.avatar_url || '/default-avatar.png'}
                            alt="Profile"
                            className="profile-photo"
                            onError={(e) => {
                                e.target.src = '/default-avatar.png';
                            }}
                        />
                        <div className="dropdown-content">
                            <a onClick={handleTakeAssessment}>
                                Take Assessment
                            </a>
                            {isAdmin && (
                                <a onClick={handleManageAssessment}>
                                    Admin Panel
                                </a>
                            )}
                            <a onClick={handleLogout} style={{ color: '#dc3545' }}>
                                <LogOut size={16} style={{ marginRight: '8px' }} />
                                Logout
                            </a>
                        </div>
                    </div>
                ) : (
                    <button className="login-btn" onClick={handleLogin}>
                        <LogIn size={18} />
                        <span>Login</span>
                    </button>
                )}
            </div>
        </nav>
    );
};

export default Navbar;